module.exports = __webpack_public_path__ + "img/37505-009.4f758d14.jpg";